import { bm } from '@core-utils/bem';
import styles from './Button.module.scss';

export const buttonStyles = {
    blockScope: styles.Button,
    outlinedMagenta: styles[bm('form__button', 'outlined-magenta')]
}